// extracted by css-extract-rspack-plugin
export default {"dropzone":"yMoSp","dropzoneActive":"me3BO","dropzoneError":"PVEu5"};